'use client';
import { IRepositoryEntry } from '@/types';
import Input from '@/components/Input';
import * as Icon from '@/ui/Icon';

const FileSelect: React.FC<{
  placeholder: string;
  selected?: IRepositoryEntry;
  entries: IRepositoryEntry[];
  onChange: (entry: IRepositoryEntry | undefined) => void;
  disabled?: boolean;
}> = ({ placeholder, entries, selected, onChange, disabled }) => {
  const entryOptions = entries
    .sort((a, b) => ((a.resource?.path || '') > (b.resource?.path || '') ? 1 : -1))
    .map((entry) => ({ value: entry.resource?.path, label: entry.resource?.path }));

  const handleChange = (value: string) => {
    const entry = entries.find((entry) => entry.resource?.path === value);
    onChange(entry);
  };

  const selectedValue = selected?.resource?.path;

  return (
    <Input.SelectControl
      name="file-path"
      wide
      disabled={disabled}
      options={entryOptions}
      selectedValue={selectedValue}
      onChange={handleChange}
      isSearchable={false}
      placeholder={placeholder}
      prefixElement={<Icon.File className="prefix-icon" />}
      styles={{
        option: (styles, state) => ({
          ...styles,
          whiteSpace: 'nowrap',
        }),
      }}
    ></Input.SelectControl>
  );
};

export default FileSelect;
